import React from 'react'
import Classes from '../Information.module.css'
const PlusIcon = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" {...props} viewBox="0 0 448 512"><path d="M256 80c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 144L48 224c-17.7 0-32 14.3-32 32s14.3 32 32 32l144 0 0 144c0 17.7 14.3 32 32 32s32-14.3 32-32l0-144 144 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-144 0 0-144z" /></svg>
)

export default function Addresses({ handleNext, handleBack, formData, setFormData }) {
  const addAddress = () => {
    setFormData({
      ...formData,
      addresses: [...formData.addresses, { addressLine1: '', addressLine2: '', city: '', state: '', zipcode: '', country: '' }]
    });
  };

  const handleAddressChange = (index, field, value) => {
    const newAddresses = [...formData.addresses];
    newAddresses[index][field] = value;
    setFormData({ ...formData, addresses: newAddresses });
  };

  return (
    <>
      <div className={Classes.infoCon} >
        <div>
          <h3>Addresses</h3>
        </div>
        <div className={Classes.infoConMiddle} >
          {formData.addresses.map((addr, index) => (
            <div key={index}>
              <div className={Classes.flexColGroup} >
                <div className={Classes.flexCol1} >
                  <h5 className={Classes.label} >Address Line 1 (optional)</h5>
                  <textarea
                    type='text'
                    value={addr.addressLine1}
                    onChange={(e) => handleAddressChange(index, 'addressLine1', e.target.value)}
                    className={Classes.inputField}
                    placeholder='Street address, P.O. box, company name, c/o'
                    rows={3}
                    style={{ height: 'auto', paddingTop: '5px' }}
                  ></textarea>
                </div>
                <div className={Classes.flexCol1} >
                  <h5 className={Classes.label} >Address Line 2 (optional)</h5>
                  <textarea
                    type='text'
                    value={addr.addressLine2}
                    onChange={(e) => handleAddressChange(index, 'addressLine2', e.target.value)}
                    className={Classes.inputField}
                    placeholder='Apartment, suite, unit, building, floor, etc.'
                    rows={3}
                    style={{ height: 'auto', paddingTop: '5px' }}
                  ></textarea>
                </div>
              </div>
              <div className={Classes.flexColGroup} >
                <div className={Classes.flexCol1} >
                  <h5 className={Classes.label} >City (optional)</h5>
                  <input
                    type='text'
                    value={addr.city}
                    onChange={(e) => handleAddressChange(index, 'city', e.target.value)}
                    className={Classes.inputField}
                    placeholder='City'
                  />
                </div>
                <div className={Classes.flexCol1} >
                  <h5 className={Classes.label} >State (optional)</h5>
                  <input
                    type='text'
                    value={addr.state}
                    onChange={(e) => handleAddressChange(index, 'state', e.target.value)}
                    className={Classes.inputField}
                    placeholder='State'
                  />
                </div>
                <div className={Classes.flexCol1} >
                  <h5 className={Classes.label} >Zipcode (optional)</h5>
                  <input
                    type='text'
                    value={addr.zipcode}
                    onChange={(e) => handleAddressChange(index, 'zipcode', e.target.value)}
                    className={Classes.inputField}
                    placeholder='Zipcode'
                  />
                </div>
              </div>
              <div className={Classes.flexColGroup} >
                <div className={Classes.flexCol1} >
                  <h5 className={Classes.label} >Country (optional)</h5>
                  <input
                    type='text'
                    value={addr.country}
                    onChange={(e) => handleAddressChange(index, 'country', e.target.value)}
                    className={Classes.inputField}
                    placeholder='Country'
                  />
                </div>
                <div className={Classes.flexCol1} ></div>
                <div className={Classes.flexCol1} ></div>
              </div>
            </div>
          ))}
          <div className={Classes.textInstructions} >
            <h5 className={`${Classes.textBold} mb-10`} >Past Addresses</h5>
            <h5 className={Classes.text} > Be sure to include all previous addresses you would like to be removed. </h5>
          </div>
          <div className={Classes.flexAlign10} style={{ cursor: 'pointer' }} onClick={addAddress} >
            <PlusIcon height='17px' width='17px' fill='#006B32' />
            <h5 className={Classes.coloredText} >Add Alternative Address</h5>
          </div>
        </div>
        <div>
          <div className={Classes.flexEnd} >
            <div className={Classes.flexAlign10} >
              <button className={Classes.backBtn} onClick={handleBack} > <h5>Back</h5> </button>
              <button className={Classes.nextBtn} onClick={handleNext} > <h5>Next</h5> </button>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}